module.exports = __webpack_public_path__ + "static/Julia John - Patternmaking from the Body-de8f9a937771be0ac49b4a76c1df20de.pdf";